import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletAccountBindingCollectionResponse } from '../../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletAccountRepository } from '../../repository/fs-wallet-account.repository';

@Injectable({
  providedIn: 'root',
})
export class BindWalletUsecase
  implements
    UseCase<string, HttpWalletAccountBindingCollectionResponse>
{
  constructor(private repository: FSWalletAccountRepository) {}

  execute(
    wallet_id: string
  ): Observable<HttpWalletAccountBindingCollectionResponse> {
    return this.repository.WalletBinding(wallet_id);
  }
}
